export const TABLE_COLUMNS_NAMES = [
	{ dataIndex: 'id', title: '#', width: '180px', align: 'left' },
	{ dataIndex: 'text', title: 'Название' },
];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
